module.exports = __webpack_public_path__ + "static/media/216-england.ceb03109.svg";